// External Imports
import { h } from 'preact';
import {
  FlagDeu,
  FlagFra,
  FlagIta,
  FlagSpa,
  Layout,
  Stack,
  Title,
  pxToRem,
  styled,
} from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Internal Imports
import { useStore } from '../../state/context';
import { TestimonialCard } from './TestimonialCard';
import { Carousel, controlsPositionValue } from '../Carousel/Carousel';
import { pxToRemParse } from '../../utils/styles';
import { LayoutWithSiteMaxWidth } from '../LayoutWithSiteMaxWidth/LayoutWithSiteMaxWidth';

// Local Variables
const TestimonialSectionWrapper = styled(Layout)`
  background-color: ${({ theme }) => theme.color.brand.default};
`;
const Column = styled(Stack)`
  min-width: ${pxToRemParse(tokens.viewports.breakpoints.xxsmall)};
  width: 100%;
`;

// the Carousel takes an unexpected amount of space if the width is not set as 100%
const CarouselContainer = styled.div`
  width: 100%;
`;

function TestimonialsSection() {
  const { t } = useStore();
  const testimonialsList = [
    {
      comment: t.testimonials.one.quote,
      FlagComponent: FlagFra,
      learningLanguage: t.testimonials.one.language,
      name: t.testimonials.one.name,
    },
    {
      comment: t.testimonials.two.quote,
      FlagComponent: FlagSpa,
      learningLanguage: t.testimonials.two.language,
      name: t.testimonials.two.name,
    },
    {
      comment: t.testimonials.three.quote,
      FlagComponent: FlagDeu,
      learningLanguage: t.testimonials.three.language,
      name: t.testimonials.three.name,
    },
    {
      comment: t.testimonials.four.quote,
      FlagComponent: FlagIta,
      learningLanguage: t.testimonials.four.language,
      name: t.testimonials.four.name,
    },
  ];
  return (
    <TestimonialSectionWrapper
      align="center"
      alignItems="center"
      gap={tokens.space.x8}
      padding={{ medium: [pxToRem(80), pxToRem(176)], small: [pxToRem(48), pxToRem(16)] }}
    >
      <LayoutWithSiteMaxWidth
        align="center"
        alignItems="center"
        direction={{ small: 'inline', xxxsmall: 'stack' }}
        gap={tokens.space.x8}
      >
        <Title
          as="h2"
          color="inverse"
          size={{ small: 'large', xsmall: 'small' }}
          textAlign={{ medium: 'left', xsmall: 'center' }}
        >
          {t.testimonials.headline}
        </Title>
        <Column align="center" alignItems="center">
          <CarouselContainer>
            <Carousel
              controlsPosition={{
                small: controlsPositionValue.sides,
                xxsmall: controlsPositionValue.bottomCenter,
              }}
            >
              {testimonialsList.map(({ comment, FlagComponent, learningLanguage, name }) => (
                <TestimonialCard
                  FlagComponent={FlagComponent}
                  comment={comment}
                  key={comment}
                  learningLanguage={learningLanguage}
                  name={name}
                />
              ))}
            </Carousel>
          </CarouselContainer>
        </Column>
      </LayoutWithSiteMaxWidth>
    </TestimonialSectionWrapper>
  );
}

export { TestimonialsSection };
